<template>
    <div>
        <div class="page-container">
            <md-app md-waterfall md-mode="fixed">
                <md-app-toolbar class="md-primary">
                    <span class="md-title">小云客户设备管理系统</span>
                    <div class="md-toolbar-section-end">

                        <md-menu md-direction="bottom-end" :mdCloseOnClick="true">
                            <md-button md-menu-trigger class="md-icon-button">
                                <md-icon>more_vert</md-icon>
                            </md-button>

                            <md-menu-content>
                                <md-menu-item @click="toHome">返回主页</md-menu-item>
                                <md-menu-item @click="visualization" v-if="superAdmin">数据可视化</md-menu-item>
                                <md-menu-item @click="visualizationSettings" v-if="superAdmin">数据可视化管理</md-menu-item>
                                <md-menu-item @click="managerVersion" v-if="superAdmin">APP版本管理</md-menu-item>
                                <md-menu-item @click="managerUser" v-if="superAdmin">用户管理</md-menu-item>
                                <md-menu-item @click="managerVCode" v-if="superAdmin">奖励管理</md-menu-item>
                                <md-menu-item @click="managerResource" v-if="superAdmin">资源管理</md-menu-item>
                                <md-menu-item @click="managerQQMusic" v-if="superAdmin">QQ音乐管理</md-menu-item>
                                <md-menu-item @click="warningsDevices" v-if="superAdmin">异常设备</md-menu-item>
                                <md-menu-item @click="genExcel" v-if="superAdmin">MAC批量生成</md-menu-item>
                                <md-menu-item @click="logout">退出登录</md-menu-item>
                            </md-menu-content>
                        </md-menu>

                    </div>

                </md-app-toolbar>

                <!--                <md-app-drawer md-permanent="full">-->
                <!--                    <md-toolbar class="md-transparent" md-elevation="0">-->
                <!--                        菜单-->
                <!--                    </md-toolbar>-->

                <!--                    <md-list>-->
                <!--                        <md-list-item>-->
                <!--                            <span class="md-list-item-text">系统主页</span>-->
                <!--                        </md-list-item>-->

                <!--                        <md-list-item>-->
                <!--                            <span class="md-list-item-text">客户管理</span>-->
                <!--                        </md-list-item>-->

                <!--                        <md-list-item>-->
                <!--                            <span class="md-list-item-text">单独设备管理</span>-->
                <!--                        </md-list-item>-->

                <!--                    </md-list>-->
                <!--                </md-app-drawer>-->

                <md-app-content>
                    <router-view></router-view>
                </md-app-content>
            </md-app>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dashboard",
        data: () => ({
            superAdmin: false,
        }),
        mounted: function () {
            this.load();
        },
        methods: {
            load() {
                let userToken = localStorage.getItem('user_data');
                if (!userToken) {
                    this.$router.replace('/login')
                } else {
                    let userInfo = JSON.parse(localStorage.getItem('user_info'));
                    this.superAdmin = userInfo.role === 1;
                }
            },
            toHome() {
                this.$router.replace('/')
            },
            visualization() {
                this.$router.replace('/main')
            },
            visualizationSettings() {
              this.$router.push('/dashboard/static-settings')
            },
            logout() {
                this.$http.post('/api/user/logout/').then(() => {
                    localStorage.clear();
                    this.$router.replace('/login')
                })
            },
            managerVersion() {
                this.$router.push('/dashboard/version')
            },
            managerUser() {
              this.$router.push('/dashboard/user')
            },
            managerVCode() {
                this.$router.push('/dashboard/vcode')
            },
            managerResource() {
              this.$router.push('/dashboard/resource')
            },
            managerQQMusic() {
              this.$router.push('/dashboard/qq-music')
            },
            warningsDevices() {
                this.$router.push('/dashboard/warnings')
            },
            genExcel() {
                this.$router.push('/dashboard/excel')
            },
        }
    }
</script>

<style lang="scss" scoped>
    .md-app {
        max-height: 100%;
    }

    // Demo purposes only
    .md-drawer {
        width: 130px;
        max-width: calc(100vw - 125px);
    }
</style>